import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { KBWMonitoringService } from './logging.service';
@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private KBWMonitoringService: KBWMonitoringService) {
        super();
    }

    handleError(error: Error) {
        this.KBWMonitoringService.logException(error); // Manually log exception
    }
}